module.exports = __webpack_public_path__ + "img/9.d121257d.jpg";